// THE CALL'S SOUND — one <audio> per remote member at the shell root, beside
// the dock (workspace app.js mounts `MeetCallAudio` next to MeetCallWidget),
// so a live call keeps playing on every route: the tiles' own <audio>
// unmounted with /meet and a call went silent behind the dock (a Codex review
// of the call theater, 2026-10-18). The element renders nothing on screen; the
// track reaches it from its render (functions/callAudio.js) and from
// connectCall's track events (functions/attachTracks.js). A member who leaves
// takes their element with them; a call that ends empties the list.
export const MeetCallAudio = {
  dataMeetCallAudio: true,
  display: 'none',
  ariaHidden: 'true',
  childrenAs: 'state',
  // the call's own list — read here, so the host re-runs on every change
  children: (el, s) => el.call('meetCallAudioMembers', s.root),
  childrenDeps: ['livekitParticipants'],
  childProps: {
    tag: 'audio',
    dataMeetAudioFor: (el, s) => (s && s.identity) || null,
    autoplay: 'autoplay',
    onRender: (el, s) => el.call('meetCallAudioAttach', el, s)
  }
}
